import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import UltimosAcessados from "./UltimosAcessados";
import AICopilotBanner from "./AICopilotBanner";
import ListagemPacientes from "./ListagemPacientes/ListagemPacientes";
import { TextsProps } from "../../database/txt.interface";
import { makeStyles } from "@material-ui/core";
import PrincipalAddButton from "./PrincipalAddButton/PrincipalAddButton";
import { DashBoardActions } from "../../store/ducks/dashboard";
import InputPesquisaPaciente from "./InputPesquisaPaciente/InputPesquisaPaciente";
import { ContainerDash } from "../../styles/global";
import { AtribuirActions } from "../../store/ducks/atribuir";
import { AppActions } from "../../store/ducks/app";
import ToastAlert from "../../components/toast";
import Loading from "./Loading";
import moment from "moment";
import {
	loadStorage,
	persistStorage,
	removeItemStorage,
} from "../../utils/base_async_storage";
import axios from "axios";
import { UserProps } from "../../interfaces/pacientes.interface";
import { Colors } from "../../styles/colors";
import { ReactComponent as Close } from "../../assets/kinologyIcons/svg/close.svg";
import { ReactComponent as Warning } from "../../assets/kinologyIcons/svg/WaringRedRound.svg";
import { ReactComponent as WarningYellow } from "../../assets/kinologyIcons/svg/warningInvoices.svg";
import { FinancialActions } from "../../store/ducks/financial";
import { ReactComponent as Battery50 } from "../../assets/icons/battery-50.svg";
import { ReactComponent as Battery10 } from "../../assets/icons/battery-10.svg";
import { useDataSubscription } from "../../hooks/useDataSubscription";

type typeOptions =
	| "excluir"
	| "condicao_fisica"
	| "avaliador"
	| "etiqueta"
	| "";

const Pacientes: React.FC = () => {
	const dispatch = useDispatch();
	const { hasOperationalDashboardAccess } = useDataSubscription();

	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	const search = useSelector((state: any) => state.dashboard.search);

	const option: typeOptions = useSelector(
		(state: any) => state.atribuir.menu_option_selected
	);

	const pacientes = useSelector((state: any) => state.dashboard.pacientes);

	const pacientes_selecionados = useSelector(
		(state: any) => state.app.lista_pacientes
	);
	const current_page: string = useSelector(
		(state: any) => state.dashboard.current_page
	);

	const dino_battery = useSelector((state: any) => state.configs.dino_battery);
	const device_name: string = useSelector(
		(state: any) => state.configs.device_name
	);
	const is_open_toast = useSelector((state: any) => state.app.is_open_toast);
	const user_logado: UserProps = useSelector((state: any) => state.auth.user);
	const config_servicos = useSelector(
		(state: any) => state.configs.config_servicos
	);

	const useStyles = makeStyles(() => ({
		root: {
			"& .MuiPagination-ul": {
				justifyContent: "left",
			},
			"& .MuiPaginationItem-root": {
				color: "black",
				"&:hover": {
					backgroundColor: "#000E4B",
					color: "white",
				},
			},
			"& .MuiPagination-outlined": {
				backgroundColor: "#000E4B",
			},
			"& .Mui-selected": {
				backgroundColor: "#000E4B",
				color: "#000E4B",
				"&:hover": {
					color: "black",
				},
			},
		},
	}));

	const classes = useStyles();

	const handleOptionsMenu = (option: typeOptions, event: any) => {
		event.stopPropagation();
		if (option == "etiqueta") {
			dispatch(AppActions.set_modal_atribuir_etiqueta(true));
		}
		if (option == "condicao_fisica") {
			dispatch(AppActions.set_modal_atribuir_fisica(true));
		}
		if (option == "avaliador") {
			dispatch(AppActions.set_modal_atribuir_avaliador(true));
		}
		if (option == "excluir") {
			dispatch(AppActions.set_modal_excluir_paciente(true));
		}
	};

	const traducoes_botoes: Record<typeOptions, string | undefined> = {
		excluir: current_language?.excluir_paciente,
		condicao_fisica: current_language?.atribuir_cond_fisica,
		avaliador: current_language?.atribuir_avaliador,
		etiqueta: current_language?.atribuir_etiqueta,
		"": "",
	};

	const [warningDinoBattery, setWarningDinoBattery] = useState(false);
	const [dataResponse, setDataResponse] = useState("");
	const [warningPayment, setWarningPayment] = useState({
		warningPaymentError: false,
		warningEnvoiceIsDueToday: false,
		warningEnvoiceExpired: false,
	});

	async function getSavedData() {
		loadStorage("last_invoice_pending")
			.then((response: any) => {
				if (response) {
					const validate = moment(response?.data_vencimento, "YYYY-MM-DD");
					const now = moment();
					const diffDias = now.diff(validate, "days");

					if (response?.error) {
						setWarningPayment({
							warningEnvoiceExpired: false,
							warningEnvoiceIsDueToday: false,
							warningPaymentError: true,
						});
						return;
					}
					if (diffDias >= 1 && diffDias < 8) {
						setWarningPayment({
							warningEnvoiceExpired: true,
							warningEnvoiceIsDueToday: false,
							warningPaymentError: false,
						});
						return;
					}
					if (diffDias === 0) {
						setWarningPayment({
							warningEnvoiceExpired: false,
							warningEnvoiceIsDueToday: true,
							warningPaymentError: false,
						});
						return;
					}
					if (diffDias >= 8) {
						dispatch(
							FinancialActions.set_number_pendding_envoice_days(diffDias)
						);
					}
				}
				if (!response) {
					setWarningPayment(() => ({
						warningEnvoiceExpired: false,
						warningEnvoiceIsDueToday: false,
						warningPaymentError: false,
					}));
				}
			})
			.catch((error) => {
				setWarningPayment(() => ({
					warningEnvoiceExpired: false,
					warningEnvoiceIsDueToday: false,
					warningPaymentError: false,
				}));
			});
	}

	useEffect(() => {
		dispatch(DashBoardActions.exercices_request());
	}, [user_logado]);

	useEffect(() => {
		if (user_logado) {
			const getDataClientEnvoices = async () => {
				try {
					const dataRequest = {
						id_usuario: String(user_logado.ID_USUARIO),
					};
					const config = {
						headers: {
							"Content-Type": "application/json",
							n8n_token: process.env.REACT_APP_N8N_TOKEN,
						},
					};
					const response = await axios.post(
						"https://n8n.kinology.com.br/webhook/last_invoice_pending",
						dataRequest,
						config
					);

					if (response.status === 200) {
						await removeItemStorage("last_invoice_pending");
						await persistStorage({
							res: response.data,
							tag: "last_invoice_pending",
						});
						setDataResponse(response.data);
					}
				} catch (error: any) {}
			};
			getDataClientEnvoices()
				.then(async () => {
					await getSavedData();
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}, [user_logado?.ID_USUARIO, user_logado?.token]);
	useEffect(() => {
		if (dataResponse != "") {
			getSavedData();
		}
	}, [current_page, dataResponse]);

	function PaymentErrorWarning() {
		return (
			<ContainerPaymentErrorWarning>
				<TextWarningPayment
					style={{
						display: "inline-flex",
						alignItems: "center",
					}}
				>
					<Warning
						color={Colors.tertirary_red_1_dark}
						style={{ marginRight: 5 }}
					/>
					{current_language?.erro_pagamento_fatura_cliente1}
					<TextWarningPayment
						bold
						onClick={() => {
							if (config_servicos?.SERVICO_SUPERLOGICA) {
								dispatch(
									DashBoardActions.set_current_page("pagamentos_external")
								);
							}
						}}
						style={{
							textDecorationLine: "underline",
							marginLeft: 3,
							textDecorationColor: Colors.neutral_grey_k_70,
							cursor: "pointer",
						}}
					>
						{current_language?.erro_pagamento_fatura_cliente2}
					</TextWarningPayment>
				</TextWarningPayment>
			</ContainerPaymentErrorWarning>
		);
	}
	function ExpiresToday() {
		return (
			<ContainerExpiresToday>
				<TextWarningPayment
					bold={false}
					style={{
						display: "inline-flex",
					}}
				>
					<WarningYellow
						color={Colors.tertiary_orange_1_dark}
						width={20}
						height={20}
						style={{ marginRight: 8 }}
					/>
					{current_language?.sua_fatura_vence_hoje_nao_deixe1}
					<TextWarningPayment bold={false}>
						{current_language?.sua_fatura_vence_hoje_nao_deixe2}
					</TextWarningPayment>
					<TextWarningPayment
						bold
						onClick={() => {
							if (config_servicos?.SERVICO_SUPERLOGICA) {
								dispatch(
									DashBoardActions.set_current_page("pagamentos_external")
								);
							}
						}}
						style={{
							cursor: "pointer",
							textDecorationLine: "underline",
							marginLeft: 3,
							textDecorationColor: Colors.neutral_grey_k_70,
						}}
					>
						{current_language?.evite_bloqueio_app2}
					</TextWarningPayment>
				</TextWarningPayment>
			</ContainerExpiresToday>
		);
	}
	function AvoidBlocking() {
		return (
			<ContainerAvoidBlocking>
				<Warning color={Colors.tertirary_red_1_dark} />
				<TextWarningPayment
					style={{
						display: "inline-flex",
						textAlign: "center",
						marginLeft: 8,
					}}
				>
					{current_language?.evite_bloqueio_app1}
					<TextWarningPayment
						bold
						onClick={() => {
							if (config_servicos?.SERVICO_SUPERLOGICA) {
								dispatch(
									DashBoardActions.set_current_page("pagamentos_external")
								);
							}
						}}
						style={{
							marginLeft: 3,
							textDecorationLine: "underline",
							textDecorationColor: Colors.neutral_grey_k_70,
							cursor: "pointer",
						}}
					>
						{current_language?.evite_bloqueio_app2}
					</TextWarningPayment>
					<TextWarningPayment
						style={{
							marginLeft: 3,
							textAlign: "center",
						}}
					>
						{current_language?.evite_bloqueio_app3}
					</TextWarningPayment>
				</TextWarningPayment>
			</ContainerAvoidBlocking>
		);
	}

	useEffect(() => {
		if (dino_battery && dino_battery <= 20) {
			setWarningDinoBattery(true);
		} else {
			setWarningDinoBattery(false);
		}
		if (dino_battery == 20) {
			dispatch(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: "battery20",
					message_toast:
						device_name != "Palmar_v1"
							? current_language?.carregue_seu_dinamo
							: current_language?.carregue_seu_dinamo_palmar,
				})
			);
		}
		if (dino_battery == 10 || dino_battery == 5) {
			dispatch(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: "battery10",
					message_toast:
						device_name != "Palmar_v1"
							? current_language?.carregue_seu_dinamo
							: current_language?.carregue_seu_dinamo_palmar,
				})
			);
		}
	}, [dino_battery]);

	return (
		<ContainerDash>
			<ContainerWarningPayment
				style={{
					position: "relative",
				}}
				visible={Object.values(warningPayment).some((item) => !!item)}
				bg={warningPayment.warningEnvoiceIsDueToday ? "#E59D4533" : "#E5887333"}
			>
				<div
					style={{
						position: "absolute",
						cursor: "pointer",
						right: 10,
						top: 5,
						zIndex: 2,
					}}
					onClick={() =>
						setWarningPayment(() => ({
							warningEnvoiceExpired: false,
							warningEnvoiceIsDueToday: false,
							warningPaymentError: false,
						}))
					}
				>
					<Close color={Colors.primary_blue_k_main} height={10} width={10} />
				</div>

				{warningPayment.warningPaymentError && <PaymentErrorWarning />}
				{warningPayment.warningEnvoiceIsDueToday && <ExpiresToday />}
				{warningPayment.warningEnvoiceExpired && <AvoidBlocking />}
			</ContainerWarningPayment>
			{is_open_toast && <ToastAlert />}
			{hasOperationalDashboardAccess && <AICopilotBanner />}
			<UltimosAcessados />
			<div
				className="w-[60%] h-12  flex-row items-center mt-6 justify-center p-2 text-[#2A3048]"
				style={{
					backgroundColor: dino_battery <= 10 ? "#F8EFEC" : "#E59D451A",
					display: warningDinoBattery ? "flex" : "none",
				}}
			>
				{dino_battery <= 10 ? (
					<Battery10
						color="#A81F00"
						style={{ height: 20, width: 20, marginRight: 5 }}
					/>
				) : (
					<Battery50 color="#E57E00" style={{ height: 30, width: 30 }} />
				)}
				<p
					className="ml-0.5 mr-1 font-medium"
					style={{
						color: dino_battery <= 10 ? "#A81F00" : "#E57E00",
						fontFamily: "NotoSans-Regular",
					}}
				>
					{dino_battery + "%"}
				</p>
				{`| ${current_language?.dino_bateria}`}
			</div>
			<InputPesquisaPaciente />

			{pacientes?.length > 0 ? (
				<ListagemPacientes />
			) : pacientes == null ? (
				<div style={{ width: "60%" }}>
					<Loading />
				</div>
			) : (
				<NenhumPaci>{current_language?.adicione_para_comecar}</NenhumPaci>
			)}
			<PaginationAndAddButton>
				{option == "" && <PrincipalAddButton />}

				<div style={{ display: "flex", flexDirection: "row" }}>
					{option != "" && (
						<ButtomCancel
							onClick={() => {
								dispatch(AtribuirActions.set_menu_option_selected(""));
								dispatch(AppActions.set_lista_pacientes([]));
							}}
						>
							{current_language?.botao_cancelar}
						</ButtomCancel>
					)}

					{option != "" && (
						<Buttom
							active={pacientes_selecionados.length > 0 ? true : false}
							background={option == "excluir" ? "#DC8D7C" : "#AEA9B4"}
							backgroundActive={option == "excluir" ? "#D12600" : "#001574"}
							hover={option == "excluir" ? "#A81F00" : "#000E4B"}
							onClick={(event) =>
								pacientes_selecionados.length > 0
									? handleOptionsMenu(option, event)
									: false
							}
						>
							{traducoes_botoes[option]}
						</Buttom>
					)}
				</div>
			</PaginationAndAddButton>
		</ContainerDash>
	);
};

const NenhumPaci = styled.div`
	width: 60%;
	font-family: "NotoSans-Regular";
	font-size: 1rem;
	font-weight: 400;
	text-align: left;
	margin-top: 4vh;
	color: #797d8d;
`;

const PaginationAndAddButton = styled.div`
	position: fixed;
	bottom: 0;
	width: 56%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 1.5rem;
	padding-top: 0.5rem;
	background-color: #fafafa;
`;

interface ActiveProps {
	active: boolean;
	backgroundActive: string;
	background: string;
	hover: string;
}

const Buttom = styled.div<ActiveProps>`
	padding: 0.8rem;
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	background-color: ${({ active, background, backgroundActive }) =>
		active ? backgroundActive : background};
	border-radius: 45px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	color: #fafafa;
	font-family: "NotoSans-regular";
	font-size: 1rem;
	font-weight: 700;
	text-align: left;
	cursor: pointer;

	&:hover {
		background-color: ${({ hover }) => hover};
	}
`;

const ButtomCancel = styled.div`
	padding: 0.8rem;
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	background-color: #dedfe3;
	border-radius: 45px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	color: #3d4259;
	font-family: "NotoSans-regular";
	font-size: 1rem;
	font-weight: 700;
	text-align: left;
	cursor: pointer;
	border: 1px solid #3d4259;
	margin-right: 1rem;

	&:hover {
		background-color: #abadb7;
	}
`;
export const ContainerWarningPayment = styled.div<{
	bg: string;
	visible: boolean;
}>`
	display: ${({ visible = false }) => (visible ? "flex" : "none")};
	background-color: ${({ bg }) =>
		bg ? bg : Colors.tertiary_orange_1_light + 33};
	width: 100%;
	height: 70px;
	padding: 3px 0px;
	align-items: center;
	justify-content: center;
`;
export const ContainerPaymentErrorWarning = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
`;
export const TextWarningPayment = styled.p<{ bold?: boolean }>`
	font-size: 16px;
	color: ${Colors.neutral_grey_k_70};
	font-family: "NotoSans-Regular";
	text-align: center;
	font-weight: ${({ bold }) => (bold ? "700" : "400")};
`;
export const ContainerAvoidBlocking = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;
export const ContainerExpiresToday = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export default Pacientes;
